import { ControlType, Field, Section } from "@cotecna/dynamic-view-engine";

const ADD_DATES_FIELDS: Field[] = [
  {
    id: "date",
    type: ControlType.MultiDateTimePicker,
    label: "Inspection Dates",
    order: 1,
    propertyName: "inspectionDate",
    value: "",
    required: true,
    visible: true,
    valid: true,
  },
];

export const NATURAL_CONTROLS: any[] = [
  {
    id: "date",
  },
];

export const ADD_DATES_FORM: Section[] = [
  {
    id: "add-dates",
    name: "",
    isFixed: true,
    order: 1,
    fields: ADD_DATES_FIELDS,
  },
];
